// removed by extract-text-webpack-plugin
module.exports = {"Title":"_3pzNLP4sp9V2w2dYX-YRGk","Body":"_1vx-4BpqKu3zZ2hvwiZ01B"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/Standard/style.css
// module id = 1866
// module chunks = 0